import MusicPackageCreate from './MusicPackageCreate'
import MusicPackageEdit from './MusicPackageEdit'
import { buildPackageList } from 'ui-shared/WrappedInputs/Packages/BasePackageList'

const musicPackageIndex = {
  list: buildPackageList('musics'),
  edit: MusicPackageEdit,
  create: MusicPackageCreate,
}

export default musicPackageIndex
